export default "__VITE_ASSET__8a625e54__"